export default __webpack_public_path__ + "static/media/dra-alessandra.e6339c7a.webp";